
import { TokenInterceptor } from "./token.interceptor";
import { JsonApiService } from "./json-api.service";
import { UserService } from "./user.service";
import { NotificationService } from "./notification.service";
// import { LayoutService } from "./layout.service";



export const services = [
  TokenInterceptor,

  JsonApiService,
  UserService,
  NotificationService,
  // LayoutService,
];

export * from "./token.interceptor";
export * from "./json-api.service";
export * from "./user.service";
export * from "./notification.service";
// export * from "./layout.service";
